import React from 'react'

const styles = require('./page-container.module.scss')

interface PageContainerProps {
    children: React.ReactChildren | React.ReactChild
}

export const PageContainer: React.FC<PageContainerProps> = props => {
    return (
        <div className={styles.pageContainer}>
            <div className={styles.content}>
                { props.children }
            </div>
        </div>
    )
}
